export default __webpack_public_path__ + "static/media/kone-information.73b6ac22.png";